import { NavLink, Outlet } from "react-router-dom";
import { crmConfigured } from "../../lib/crm-client";

const NAV_ITEMS = [
  { to: "/crm/today", label: "Aujourd'hui" },
  { to: "/crm/estrellas", label: "Estrellas" },
  { to: "/crm/touchpoints", label: "Touchpoints" },
  { to: "/crm/batches", label: "Batches" },
  { to: "/crm/leads", label: "Leads" },
  { to: "/crm/settings", label: "Réglages" },
];

export default function CrmLayout() {
  const todayStr = new Date().toLocaleDateString("fr-FR", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });

  return (
    <div className="min-h-screen bg-ivory">
      <header className="bg-charcoal text-ivory px-10 py-5 flex items-baseline justify-between sticky top-0 z-10">
        <div className="flex items-baseline gap-6">
          <h1 className="font-sans text-2xl font-bold tracking-tight">
            llyll · CRM
          </h1>
          <nav className="flex gap-4 font-mono text-xs uppercase">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? "text-lemonade"
                    : "text-stone opacity-60 hover:opacity-100 transition-opacity"
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-baseline gap-3">
          <span className="font-mono text-[10px] uppercase text-stone">
            {crmConfigured ? "● SUPABASE" : "▢ MOCK DATA"}
          </span>
          <span className="font-mono text-[10px] uppercase text-stone">
            {todayStr}
          </span>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
